// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"252":"css/app","364":"css/admin"}[chunkId] + ".css";
};